import { QueryEntity } from '@datorama/akita';
import { WorksheetState, WorksheetStore } from './worksheet.store';
import { Injectable } from '@angular/core';
import { map } from 'rxjs/operators';
import { WorksheetItem } from './models/worksheet-item.model';

@Injectable({ providedIn: 'root' })
export class WorksheetQuery extends QueryEntity<WorksheetState> {
  constructor(protected store: WorksheetStore) {
    super(store);
  }

  /**
   * Get all the worksheets for the route
   * @param route rotue of the current page
   */
  getWorksheetByRoute(route: string) {
    return this.selectAll({ filterBy: [(entity) => entity.RouteUrl == route] }).pipe(
      map((worksheets) => {
        return worksheets.map((w) => {
          if (!w || !w.Items){
            return w;
          }

          const itemsCopy = [...w.Items];
          return {
            ...w,
            Items: itemsCopy.sort(this._sortItemsByOrdinal)
          };
        });
      })
    );
  }

  /**
   * Has Route will return whether there is any route loaded for the page
   * @param route route of the current page
   *
   */
  hasRoute(route: string) {
    return this.getAll({ filterBy: [(entity) => entity.RouteUrl == route] }).length > 0;
  }

  /**
   * Has worksheet will return whether the worksheet id exists
   * @param worksheetId worksheet Id
   */
  hasWorksheet(worksheetId: number) {
    return this.hasEntity(worksheetId);
  }

  private _sortItemsByOrdinal(a: WorksheetItem, b: WorksheetItem) {
    if (a.Ordinal > b.Ordinal) {
      return 1;
    }

    if (b.Ordinal > a.Ordinal) {
      return -1;
    }

    return 0;
  }
}
